import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'lin-spinner',
  template: ` <mat-spinner [strokeWidth]="strokeWidth" [diameter]="diameter" color="accent"></mat-spinner> `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SpinnerComponent {
  @Input() diameter: number = 40
  @Input() strokeWidth: number = 2
}
